/**
 * External dependencies
 */
import { useMemo } from 'react';
import {
  MessageDialogObject,
  MessageConfirmObject,
  MessageSnackObject
} from '@naruto/naruto-reducers/src/stores/message/types';

/**
 * Internal dependencies
 */
import {
  postMessageDialog,
  postMessageConfirm,
  postMessageSnack,
  removeMessageDialog,
  removeMessageConfirm,
  removeMessageSnack
} from '@naruto/bgdcms/src/reducers/operations/message/actions';
import useDispatch from './useDispatch';

interface useMessageDefine {
  dialog: (dialog: MessageDialogObject) => void;
  confirm: (confirm: MessageConfirmObject) => void;
  snack: (snack: MessageSnackObject) => void;
  removeDialog: () => void;
  removeConfirm: () => void;
  removeSnack: () => void;
}

/**
 * 描述 : 取得 Redux Action 裡面關於 Message 的 Action
 */

export default function useMessage(): useMessageDefine {
  /* Global & Local State */
  const dispatch = useDispatch();
  /* Functions */
  const apiCallPostMessageDialog = (dialog: MessageDialogObject): void => {
    dispatch(postMessageDialog(dialog));
  };
  const apiCallPostMessageConfirm = (confirm: MessageConfirmObject): void => {
    dispatch(postMessageConfirm(confirm));
  };
  const apiCallPostMessageSnack = (snack: MessageSnackObject): void => {
    dispatch(postMessageSnack(snack));
  };
  const apiCallRemoveMessageDialog = (): void => {
    dispatch(removeMessageDialog());
  };
  const apiCallRemoveMessageConfirm = (): void => {
    dispatch(removeMessageConfirm());
  };
  const apiCallRemoveMessageSnack = (): void => {
    dispatch(removeMessageSnack());
  };
  /* Main */
  return useMemo(
    () => ({
      dialog: apiCallPostMessageDialog,
      confirm: apiCallPostMessageConfirm,
      snack: apiCallPostMessageSnack,
      removeDialog: apiCallRemoveMessageDialog,
      removeConfirm: apiCallRemoveMessageConfirm,
      removeSnack: apiCallRemoveMessageSnack
    }),
    []
  );
}
